import axios from 'axios';

const SchoolSubject = {
    namespaced: true,    
    actions: {
        CreateSchoolSubject({ rootState }, payload) {
            return new Promise((resolve, reject) => {  
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };                      
                axios.post(`${process.env.VUE_APP_ENV_API_URL}SchoolSubject/CreateSchoolSubject`, payload, { headers })
                    .then(resp => resp.data)
                    .then(data => {                       
                        resolve(data)
                    })
                    .catch(err => {                       
                        reject(err)
                    })
            })
        },    
        UpdateSchoolSubject({ rootState }, payload) {
            return new Promise((resolve, reject) => {  
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };                      
                axios.post(`${process.env.VUE_APP_ENV_API_URL}SchoolSubject/UpdateSchoolSubject`, payload, { headers })
                    .then(resp => resp.data)
                    .then(data => {                       
                        resolve(data)
                    })
                    .catch(err => {                       
                        reject(err)
                    })
            })
        },  
        GetSchoolSubjects({ rootState },{SchoolId,SchoolLevelId}) {
            return new Promise((resolve, reject) => {  
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };                    
                axios.get(`${process.env.VUE_APP_ENV_API_URL}SchoolSubject/PortalGetSchoolSubjects?SchoolId=${SchoolId}&SchoolLevelId=${SchoolLevelId}`, { headers })
                    .then(resp => resp.data)
                    .then(data => {                       
                        resolve(data)
                    })
                    .catch(err => {                       
                        reject(err)
                    })
            })
        }, 
        GetSchoolSubjectById({ rootState },SchoolSubjectId) {
            return new Promise((resolve, reject) => {  
                const headers = {
                    Authorization: `bearer ${rootState.auth.token}`
                };                    
                axios.get(`${process.env.VUE_APP_ENV_API_URL}SchoolSubject/PortalGetByIdSchoolSubject?SchoolSubjectId=${SchoolSubjectId}`, { headers })
                    .then(resp => resp.data)
                    .then(data => {                       
                        resolve(data)
                    })
                    .catch(err => {                       
                        reject(err)
                    })
            })
        },          
    },
}

export default SchoolSubject